module.exports = __webpack_public_path__ + "img/zipper-mouth-face.c1b46c79.png";